import styled from "styled-components";

export const ContainerEditarEndereco = styled.div`
  position: relative;

  div img {
    position: absolute;
    top: 14px;
    left: 16px;
  }
`;
